import { useLazyFetch } from "../utils/apiclient";
import { convoyTessellUrl } from "../utils/urls";
import { getHeaders } from "../utils/apiclient";

export const useListClusters = (deploymentStage) => {
  return useLazyFetch(
    `${convoyTessellUrl}/apps/tessell/deployment-stages/${deploymentStage}/clusters`,
    {
      headers: { ...getHeaders(), Action: "LIST_ALL" },
    }
  );
};

export const useGetCluster = (deploymentStage, clusterName) => {
  return useLazyFetch(
    `${convoyTessellUrl}/apps/tessell/deployment-stages/${deploymentStage}/clusters/${clusterName}`,
    {
      headers: { ...getHeaders(), Action: "GET" },
    }
  );
};
